import React from "react";
import { format } from "date-fns";
import ReactTooltip from "react-tooltip";

import { NO_DATA_FOUND } from "../../../constants";
import ProfileIcon from "../../../components/uiElements/icons/profileIcons/ProfileIcon";

const PaymentHistoryList = ({ payments, downloadInvoice }) => {
  const handleDownload = async (invoiceUrl, event) => {
    event.preventDefault();

    const link = document.createElement("a");
    link.href = invoiceUrl;
    link.download = true;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      {payments?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="blocked">
          <table class="table mt-3">
            <thead>
              <tr>
                <th className="col-3">Amount</th>
                <th className="col-5">Date</th>
                <th className="col-2"></th>
              </tr>
            </thead>
            <tbody>
              {payments &&
                payments?.map((payment, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span className="payment-amount">
                          ${payment?.amount > 0 && payment?.amount / 100}{" "}
                        </span>
                      </td>
                      <td>
                        {" "}
                        {format(
                          new Date(payment?.created * 1000),
                          "MMMM dd, yyyy"
                        )}
                      </td>
                      <td className="mr-auto" style={{ cursor: "pointer" }}>
                        {payment?.status === "succeeded" ? (
                          payment?.invoice ? (
                            <span
                              onClick={e =>
                                downloadInvoice(
                                  payment?.invoice,
                                  invoice_download => {
                                    handleDownload(invoice_download, e);
                                  }
                                )
                              }
                            >
                              <ProfileIcon type="download" /> Download Invoice{" "}
                            </span>
                          ) : (
                            payment?.receipt_url && (
                              <span
                                onClick={() =>
                                  window.open(payment?.receipt_url, "_blank")
                                }
                              >
                                <ProfileIcon type="receipt" /> View Receipt{" "}
                              </span>
                            )
                          )
                        ) : (
                          <>
                            <span
                              data-tip
                              data-for={payment?.id}
                              className="text-danger font-weight-bold"
                            >
                              <ProfileIcon type="danger" />
                              Failed
                            </span>
                            <ReactTooltip id={payment?.id}>
                              {payment?.failure_message}
                            </ReactTooltip>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default PaymentHistoryList;
